import React from 'react';
import { extensionName, isEmpty } from '../../../helpers/common';
import { ReplyMessageDataInterface } from '../../../interfaces/MessageInterface';
import { FILE_EXTENSIONS, FILE_TYPES, ICON_BUTTON_SIZE, ICON_BUTTON_TYPE } from '../../../global/constants';
import { FileIconDiv, ReplyMessageDiv } from '../styles';
import FileSVGIcon from '../../../assets/images/svg/filesIconSvg';
import { FileType } from '../../renderFilePreview/styles';
import RenderHtml from '../../renderHtml';
import IconButton from '../../button/iconButton';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

interface Props {
  replyMessage?: ReplyMessageDataInterface;
  setReplyMessage: (value: ReplyMessageDataInterface) => void;
}

function ReplyMessage(props: Props) {
  const { replyMessage, setReplyMessage } = props;
  //Other variable
  // const classList = [
  //   'figma-main-div',
  //   'youtube-preview-main-div',
  //   'screen-recording-custom-main-div',
  //   'e-rte-image e-imginline',
  //   'print-screen'
  // ];
  // const isShowInBlock = classList.some((className) => replyMessage?.Message?.includes(className));
  // const classForReply = isShowInBlock ? 'text-block' : 'text';

  return (
    <ReplyMessageDiv>
      {!isEmpty(replyMessage) && (
        <div className='thread-div'>
          <div className='content'>
            <div className='line' />

            <div className='right-div'>
              <div className='header'>
                <div className='left-header'>
                  <div className='name'>{replyMessage?.Sender || ''}</div>
                  <div className='time'>{dayjs(replyMessage?.CreatedTime).fromNow()}</div>
                </div>
                <IconButton
                  iconName='new-close-icon'
                  size={ICON_BUTTON_SIZE.EXTRA_SMALL}
                  variant={ICON_BUTTON_TYPE.TERTIARY}
                  onClick={() => setReplyMessage({})}
                  iconColorType='primary'
                />
              </div>
              {!isEmpty(replyMessage?.Message) && (
                // <div
                //   className={classForReply}
                //   dangerouslySetInnerHTML={{
                //     __html: replyMessage?.Message || ''
                //   }}
                // />
                <div className='reply-text'>
                  <RenderHtml htmlString={replyMessage?.Message || ''} isReplyText={true} />
                </div>
              )}
              {replyMessage?.Files && replyMessage?.Files?.length > 0 && (
                <div className='file-div'>
                  {replyMessage?.Files?.map((x) => {
                    const extension = extensionName(x).toLowerCase();
                    console.log('extension ====', extension);
                    return (
                      <div key={x?.href} className='image-div'>
                        {(!x?.uploadFileType || x?.uploadFileType === FILE_TYPES.UPLOAD) &&
                        !FILE_EXTENSIONS.includes(extension) ? (
                          <FileIconDiv>
                            <FileSVGIcon name={'blank'} height='32' width='32' viewBox='0 0 60 60' />
                            <FileType fontSize={extension?.length <= 4 ? 7 : 5} className='file-text'>
                              {extension?.length <= 5 && extension?.split('.')?.pop()?.toUpperCase()}
                            </FileType>
                          </FileIconDiv>
                        ) : (
                          <FileSVGIcon
                            name={
                              !x?.uploadFileType || x?.uploadFileType === FILE_TYPES.UPLOAD
                                ? extension
                                : `icon_${x?.uploadFileType}`
                            }
                            height='32'
                            width='32'
                            viewBox='0 0 60 60'
                          />
                        )}
                        {/* <SVGIcon name='gray-file-icon' width='20' height='20' viewBox='0 0 60 60' fill='none' /> */}
                        <div className='filetext'>{x?.name}</div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </ReplyMessageDiv>
  );
}

export default ReplyMessage;
